import { axios } from "../../shared/axios";
import { getDataFromStore } from "../../store/getStore"

export const getToken = (section) => {
    let auth;

    if (section) {
        auth = getDataFromStore(section);
    }
    else {
        auth = getDataFromStore("Auth");
    }

    return auth?.authToken
};

export const apiFunction = async (url, method, postData, token, extraConfig, section, extraHeader) => {
    let config = {
        method: method,
        url: url,
        data: postData || {},
    };
    let data;

    if (token) {
        let token = getToken(section);
        config = {
            ...config,
            headers: { Authorization: `Bearer ${token}` }
        };
    }

    if (extraConfig === "blob") {
        config = {
            ...config,
            responseType: 'blob',
        }
    }

    if (extraConfig === "formData") {
        config = {
            ...config,
            headers: { ...config.headers, "content-type": "multipart/form-data" },
        }
    }

    if (extraHeader) {
        config = {
            ...config,
            headers: { ...config.headers, additionalData: JSON.stringify(extraHeader) },
        }
    }


    await axios({ ...config })
        .then((res) => {
            if (extraConfig === "blob") {
                data = res.data
            }
            else {
                data = {
                    data: res.data.data ? res.data.data : false,
                    status: res.data.status === "success",
                    message: res.data.status,
                    count: res.data.count ? res.data.count : 0,
                };
            }
        })
        .catch((err) => {
            data = {
                ...err.response?.data,
                status: false,
            };
        });
    return data;
};